import { PROGRESS } from './style.css';

export const getSecondsAnimationDuration = (progress: string | null) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  (progress === PROGRESS.LESS_THAN_A_QUARTER ? '1s' : '0s');

export const getContainerBackground = (shuffleBackground: boolean) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  (shuffleBackground
    ? 'radial-gradient(50% 50% at 50% 50%, #000000 43.23%, #144F21 78.12%, #399C43 100%)'
    : 'radial-gradient(50% 50% at 50% 50%, rgba(0, 0, 0, 0.7) 38.54%, rgba(0, 0, 0, 0.2) 100%), rgba(0, 0, 0, 0.4)');

export const getFillBackground = (progress: string | null) => {
  switch (progress) {
  case PROGRESS.LESS_THAN_HALF:
    return 'radial-gradient(50% 50% at 50% 50%, #000000 45.31%, #661800 67.19%, #DF8C0F 100%)';
  case PROGRESS.LESS_THAN_A_QUARTER:
    return 'radial-gradient(50% 50% at 50% 50%, #000000 32.81%, #640834 66.67%, #FF0000 100%)';
  default:
    return 'radial-gradient(50% 50% at 50% 50%, #000000 43.23%, #144F21 78.12%, #399C43 100%)';
  }
};
